import { ContentWorkflow, WorkflowState } from '@amzn/awscat-pattern-library-service-model';
import { DateTime } from 'luxon';
import React, { ReactNode } from 'react';
import constants from '../../../common/constants';
import { Box } from '@amzn/awsui-components-core';

interface Props {
  publicationDate?: DateTime;
  workflow?: ContentWorkflow;
  label?: ReactNode;
}

const LastPublicationDate: React.FC<Props> = ({ publicationDate, workflow, label }) => {
  let displayLabel = label || (
    <span>
      <Box variant="strong">{constants.LABEL_LAST_PUBLISHED}</Box>:
    </span>
  );
  let lastDate;
  if (publicationDate) {
    lastDate = publicationDate.toLocaleString(DateTime.DATE_FULL);
  } else if (
    workflow &&
    workflow.publicationDate &&
    workflow.publicationState !== WorkflowState.UNPUBLISHED
  ) {
    lastDate = workflow.publicationDate.toLocaleString(DateTime.DATE_FULL);
  } else if (
    workflow &&
    workflow.lastPublicationUpdate &&
    workflow.publicationState === WorkflowState.UNPUBLISHED
  ) {
    lastDate = workflow.lastPublicationUpdate.toLocaleString(DateTime.DATE_FULL);
    displayLabel = (
      <span>
        <Box variant="strong">{constants.LABEL_UNPUBLISHED}</Box>:
      </span>
    );
  }
  return lastDate ? (
    <span>
      {displayLabel} {lastDate}
    </span>
  ) : null;
};

export default LastPublicationDate;
